document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-menu-toggle]').forEach((button) => {
    button.addEventListener('click', () => {
      const panel = document.querySelector('[data-mobile-menu]');
      if (!panel) return;
      const open = panel.toggleAttribute('data-open');
      button.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  document.querySelectorAll('[data-variant-select]').forEach((select) => {
    const wrapper = select.closest('[data-product-form]');
    if (!wrapper) return;
    const idInput = wrapper.querySelector('input[name="id"]');
    const price = wrapper.querySelector('[data-product-price]');
    const compare = wrapper.querySelector('[data-product-compare]');
    const button = wrapper.querySelector('[data-add-button]');
    select.addEventListener('change', () => {
      const option = select.options[select.selectedIndex];
      if (idInput) idInput.value = option.value;
      if (price && option.dataset.price) price.textContent = option.dataset.price;
      if (compare) {
        compare.textContent = option.dataset.compare || '';
        compare.hidden = !option.dataset.compare;
      }
      if (button) {
        const available = option.dataset.available === 'true';
        button.disabled = !available;
        button.textContent = available ? 'Add to cart' : 'Sold out';
      }

      const sku = wrapper.querySelector('[data-product-sku]');
      const skuRow = wrapper.querySelector('[data-sku-row]');
      if (sku) sku.textContent = option.dataset.sku || '';
      if (skuRow) skuRow.hidden = !option.dataset.sku;

      const barcode = wrapper.querySelector('[data-product-barcode]');
      const barcodeRow = wrapper.querySelector('[data-barcode-row]');
      if (barcode) barcode.textContent = option.dataset.barcode || '';
      if (barcodeRow) barcodeRow.hidden = !option.dataset.barcode;
    });
  });

  document.querySelectorAll('[data-faq-button]').forEach((button) => {
    button.addEventListener('click', () => {
      const item = button.closest('.faq-item');
      const body = item?.querySelector('.faq-answer');
      const isOpen = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      if (body) body.hidden = isOpen;
    });
  });
});
